import { useState } from "react";
import { webUrlNode } from "../../constants/appInfo";
import { useSelector } from "react-redux";

export default function AdminManualRecharge() {
const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
 
  const [form, setForm] = useState({
    appId: "",
    tenantId: "",
    channel: "email",
    credits: "",
    amountPaise: ""
  });

  async function submit() {

    if (!form.tenantId || !form.credits) {
      alert("tenantId and credits are required");
      return;
    }

    const res = await fetch(
      `${webUrlNode}/api/admin/credits/manual-recharge?appToken=${appToken}&currentToken=${currentToken}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          tenantId: Number(form.tenantId),
          channel: form.channel,
          credits: Number(form.credits),
          amountPaise: Number(form.amountPaise || 0)
        })
      }
    );

    if (!res.ok) {
      const e = await res.json();
      alert(e?.error || "Failed");
      return;
    }

    alert("Credits added");

    setForm({
      appId: "",
      tenantId: "",
      channel: "email",
      credits: "",
      amountPaise: ""
    });
  }

  return (
   <div style={styles.wrapper}>

      <div style={styles.header}>
        <h3 style={{ margin: 0 }}>Manual Recharge</h3>
        <span style={styles.badge}>ADMIN ONLY</span>
      </div>

      <div style={styles.grid}>

        {/* Tenant ID */}
        <div style={styles.field}>
          <label style={styles.label}>Tenant ID</label>
          <input
            style={styles.input}
            value={form.tenantId}
            onChange={e =>
              setForm({ ...form, tenantId: e.target.value })
            }
            placeholder="Enter tenant ID"
          />
        </div>

        {/* Channel */}
        <div style={styles.field}>
          <label style={styles.label}>Channel</label>
          <select
            style={styles.input}
            value={form.channel}
            onChange={e =>
              setForm({ ...form, channel: e.target.value })
            }
          >
            <option value="email">Email</option>
            <option value="sms">SMS</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="push">Push</option>
            <option value="ai">AI</option>
          </select>
        </div>

        {/* Credits */}
        <div style={styles.field}>
          <label style={styles.label}>Credits</label>
          <input
            type="number"
            style={styles.input}
            value={form.credits}
            onChange={e =>
              setForm({ ...form, credits: e.target.value })
            }
          />
        </div>

        {/* Amount */}
        <div style={styles.field}>
          <label style={styles.label}>
            Amount (₹) – Optional
          </label>
          <input
            type="number"
            style={styles.input}
            value={form.amountPaise}
            onChange={e =>
              setForm({ ...form, amountPaise: e.target.value })
            }
          />
          <small style={styles.helper}>
            Leave empty for free/manual bonus credit
          </small>
        </div>

      </div>

      <button style={styles.button} onClick={submit}>
        Add Credits
      </button>

      <div style={styles.warning}>
        ⚠ This action directly modifies tenant wallet balance.
      </div>

    </div>
  );
}
const styles = {
  wrapper: {
    background: "#ffffff",
    padding: 24,
    borderRadius: 14,
    boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
    maxWidth: 600,
    margin: "auto",
    fontFamily: "Inter, sans-serif"
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20
  },

  badge: {
    background: "#fee2e2",
    color: "#b91c1c",
    fontSize: 11,
    padding: "4px 10px",
    borderRadius: 20,
    fontWeight: 600
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: 16
  },

  field: {
    display: "flex",
    flexDirection: "column"
  },

  label: {
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 6,
    color: "#475569"
  },

  input: {
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    fontSize: 14
  },

  helper: {
    fontSize: 11,
    color: "#94a3b8",
    marginTop: 4
  },

  button: {
    marginTop: 20,
    width: "100%",
    padding: "10px 16px",
    borderRadius: 10,
    border: "none",
    background: "#ef4444",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer"
  },

  warning: {
    marginTop: 12,
    fontSize: 12,
    color: "#b45309"
  }
};